import { z } from 'zod';
/**
 * Validation d'une valeur JSON arbitraire à la frontière HTTP.
 *
 * Sert aux charges utiles dont la forme n'est pas connue du serveur (paramètres
 * de template, contexte fournisseur archivé) : le schéma refuse tout ce qui ne
 * survivrait pas à une sérialisation, et l'appelant récupère un `JsonValue`
 * qu'il peut restreindre par `typeof` sans assertion.
 */
export const jsonValueSchema = z.lazy(() => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(jsonValueSchema),
    z.record(jsonValueSchema),
]));
export const jsonObjectSchema = z.record(jsonValueSchema);
